import BaseAPI from "../baseAPI"

class MyAccountAPI extends BaseAPI {
  constructor() {
    super("/dashboard/my-account")
  }

  getUserDetail() {
    return this.get("", true)
  }

  updateUserDetail(data) {
    return this.patch("/update", data, true)
  }

  changePassword(data) {
    return this.patch("/change-password", data, true)
  }
}

export { MyAccountAPI as default }